<template><div><h1 id="auswertungen-veranstaltungen" tabindex="-1"><a class="header-anchor" href="#auswertungen-veranstaltungen"><span>Auswertungen Veranstaltungen</span></a></h1>
<p>Die Referenz beschreibt Auswertungen und Statistiken aus dem Bereich Veranstaltungen.</p>
<p><strong>Inhaltsverzeichnis</strong></p>
<p><RouteLink to="/referenz/refstat/ft.refstat.vrstadrlist.html">Teilnehmerliste für Veranstaltungen</RouteLink> - Drucken einer Teilnehmerliste</p>
<p><RouteLink to="/referenz/refstat/ft.refstat.vrstadrlistleiter.html">Liste der LagerleiterInnen</RouteLink> - Liste der LagerleiterInnen</p>
</div></template>


